import React from 'react';
import Text from '@amzn/meridian/text';
import DisplaySubMetric from './DisplaySubMetric';
import Row from '@amzn/meridian/row';
import { FormattedMessage } from 'react-intl';
import { DisplaySubMetricsProps } from '../types';
import {
  PRRDataCheck,
  SUBMETRIC_FONT_SIZE,
  SUBMETRIC_ROW_WIDTHS,
} from '../helper';
import Column from '@amzn/meridian/column';
import NoSubMetric from './Util/NoSubMetric';
import { validateHMDDetailsVertical } from '@amzn/aet-galactus-kit';
import { convertToVerticalOption } from '../../../../../Util/Vertical';

const DisplayPRRSubMetrics: React.FC<DisplaySubMetricsProps> = ({
  metrics,
  vertical,
  skill,
  segment,
  channel,
  timeOption,
  timestamp,
}: DisplaySubMetricsProps): React.ReactElement => {
  if (!metrics.PRR?.submetrics) {
    return <></>;
  }
  if (PRRDataCheck(metrics.PRR?.submetrics!)) {
    return <NoSubMetric />;
  }
  const { hmdNoResponses, hmdYesResponses } = metrics.PRR?.submetrics!;

  return (
    <Column spacing='none' width='100%'>
      {hmdNoResponses && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <Text type={SUBMETRIC_FONT_SIZE}>
            <FormattedMessage
              id='cs_perfportal_lighthouse_hmdNoResponses'
              defaultMessage='HMD No Responses'
            />
          </Text>
          <DisplaySubMetric
            value={hmdNoResponses.datapoint}
            isBold
            isLink={validateHMDDetailsVertical(
              convertToVerticalOption(vertical)
            )}
            vertical={vertical}
            skill={skill}
            segment={segment}
            channel={channel}
            timeOption={timeOption}
            timestamp={timestamp}
            tabRef={'hmdNo'}
          />
        </Row>
      )}
      {hmdYesResponses && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <Text type={SUBMETRIC_FONT_SIZE}>
            <FormattedMessage
              id='cs_perfportal_lighthouse_hmdYesResponses'
              defaultMessage='HMD Yes Responses'
            />
          </Text>
          <DisplaySubMetric
            value={hmdYesResponses.datapoint}
            isBold
            isLink={validateHMDDetailsVertical(
              convertToVerticalOption(vertical)
            )}
            vertical={vertical}
            skill={skill}
            segment={segment}
            channel={channel}
            timeOption={timeOption}
            timestamp={timestamp}
            tabRef={'hmdYes'}
          />
        </Row>
      )}
    </Column>
  );
};

export default DisplayPRRSubMetrics;
